export default "__VITE_ASSET__vxFD5hiM__"